<div class="header-container single">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle" aria-label="Menüyü Aç/Kapat">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()" aria-label="Ana sayfa">
      <img class="logo-img" [src]="isDark() ? 'assets/images/logo-dark.png' : 'assets/images/logo-light.png'" alt="Zenivasoft logo" />
      <span class="sr-only">Zenivasoft</span>
    </a>
  </div>
  <div class="header-actions">
    <button nbButton size="small" ghost (click)="toggleDarkMode()" nbTooltip="{{ isDark() ? 'Açık moda geç' : 'Koyu moda geç' }}" [attr.aria-label]="isDark() ? 'Açık moda geç' : 'Koyu moda geç'" class="theme-toggle">
      <nb-icon [icon]="isDark() ? 'sun-outline' : 'moon-outline'"></nb-icon>
    </button>
  </div>
</div>
